<template lang="html">

  <div class="toggle-dark-mode">

    <a class="sun" @click="requestToggle">
      <img src="/static/img/icons/sun.svg" alt="Activar modo oscuro">
    </a>
    <a class="moon" @click="requestToggle">
      <img src="/static/img/icons/moon.svg" alt="Activar modo oscuro">
    </a>

    <span class="active" :isdark="darkmode ? 'true' : 'false'"></span>

  </div>

</template>

<script lang="js">
   
     import {mapGetters,mapActions} from 'vuex';
   
     export default  {
       name: 'toggle-dark-mode',
       computed : {
         ...mapGetters({
           colors : 'basicColors',
           style : 'getStyles',
           darkmode: 'getDarkSide',
         }),
       },
       methods: {
          ...mapActions(['toggleDarkSide']),
          requestToggle(){
            this.toggleDarkSide();
            setTimeout(e => {
            },300)
          }
       },
     }
   </script>
<style lang="scss" scoped>
     .toggle-dark-mode{
  position: absolute;
  bottom: 15px;
  right: 15px;

  width: 70px;
  height: 30px;
  display: inline-block;
  border-radius: 30px;

  .active{
    width: 34px;
    height: 34px;
    display: inline-block;
    position: absolute;
    left: -2px;
    top:-2px;
    border-radius:50%;
  }

  > a{
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top:0;
    z-index: 2;

    &.moon{
      right: 0;
    }

    &.sun{
      left: 0;
    }

    img{
      width: 20px;
      display: inline-block;
    }
  }

}
   </style>


// WEBPACK FOOTER //
// src/components/parts/toggledarkmode.vue